import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import InitialPage from './initial-page';
import { styles } from './initial-page.styles';

export default compose(withStyles(styles))(InitialPage);
